import { makeStyles } from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../constants/colors';
import { INPUT } from '../../../constants/props';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginBottom: '0.625rem',
  },
  container: {
    display: 'flex',
    backgroundColor: COLORS.grayScale[5],
    overflow: 'hidden',
    borderRadius: '0.3125rem',
    '& input, & textarea': {
      width: '100%',
      fontFamily: 'Raleway',
      fontSize: '1rem',
      lineHeight: '1.1875rem',
      boxSizing: 'border-box',
      border: 'none',
      outline: 'unset',
      color: COLORS.grayScale[1],
      '&::placeholder': {
        color: COLORS.grayScale[4],
      },
    },
    '& > :first-child': {
      marginLeft: '1.25rem',
    },
    '& input': {
      height: '3.125rem',
      padding: '1.0625rem 1.25rem',
      paddingLeft: 0,
    },
    '& textarea': {
      height: '100%',
      margin: '1.0625rem 1.25rem',
      resize: (props) => props.resize,
    },
  },
  invalid: {
    '& *': {
      color: `${COLORS.error} !important`,
    },
    '& > :first-child': {
      border: `1px solid ${COLORS.error}`,
    },
  },
  message: {
    margin: 0,
    marginTop: '0.25rem',
  },
  startIcon: {
    color: COLORS.grayScale[0],
    fontSize: '1.25rem',
    lineHeight: '1.25rem',
    margin: '0.9375rem 1.13rem 0.9375rem 0',
  },
});

const Input = ({
  className,
  invalid,
  message,
  textarea,
  resize,
  startIcon,
  ...props
}) => {
  const classes = useStyles({ resize });
  return (
    <div
      className={
        invalid ? [classes.root, classes.invalid].join(' ') : classes.root
      }
    >
      <div
        className={
          className
            ? [classes.container, className].join(' ')
            : classes.container
        }
      >
        {startIcon && <div className={classes.startIcon}>{startIcon}</div>}
        {textarea ? (
          <textarea {...props} noValidate />
        ) : (
          <input {...props} noValidate />
        )}
      </div>
      {invalid && message && <p className={classes.message}>{message}</p>}
    </div>
  );
};

Input.defaultProps = {
  className: null,
  startIcon: null,
  invalid: false,
  message: null,
  textarea: false,
  resize: 'auto',
};

Input.propTypes = {
  INPUT,
};

export default Input;
